import { MESSAGE_TYPES } from "../utils/Constants";
import {
  getActivitiesCollectionRef,
  getBanListRef,
  getPropertyRef,
  getSessionRef,
  getTriggersCollection,
  getVisitorRef,
  getWidgetRef,
} from "./collectionReference";
import {
  addDoc,
  getDoc,
  setDoc,
  query,
  where,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";

export async function getWidgetSettings(data) {
  const propertyRef = getPropertyRef(data?.propertyId);
  const widgetRef = getWidgetRef(propertyRef, data?.widgetId);
  const widget = await getDoc(widgetRef);
  return { ...widget.data(), id: widget.id };
}

export async function getVisitor(identifier) {
  const visitorRef = getVisitorRef(identifier);
  const visitorSnap = await getDoc(visitorRef);
  return { ...visitorSnap.data(), id: visitorSnap.id };
}

export async function getSession(identifier, session, checkExist = false) {
  const visitorRef = getVisitorRef(identifier);
  const sessionRef = getSessionRef(visitorRef, session);
  const sessionSnap = await getDoc(sessionRef);
  if (checkExist) return sessionSnap.exists();
  else return { ...sessionSnap.data(), id: sessionSnap.id };
}

export async function updateVisitor(identifier, data) {
  const visitorRef = getVisitorRef(identifier);
  await setDoc(visitorRef, data, { merge: true });
}

export async function updateSession(identifier, session, data) {
  const visitorRef = getVisitorRef(identifier);
  const sessionRef = getSessionRef(visitorRef, session);
  await setDoc(sessionRef, data, { merge: true });
}

export async function addActivity(identifier, session, data) {
  const visitorRef = getVisitorRef(identifier);
  const sessionRef = getSessionRef(visitorRef, session);
  const activityRef = getActivitiesCollectionRef(sessionRef);
  await addDoc(activityRef, data);
}

export async function checkForIsBan(identifier) {
  const banListRef = getBanListRef(identifier);
  const banListSnap = await getDoc(banListRef);
  return banListSnap.exists();
}

export async function getWidget(propertyId, widgetId) {
  const propertyRef = getPropertyRef(propertyId);
  const widgetRef = getWidgetRef(propertyRef, widgetId);

  const widget = await getDoc(widgetRef);

  return { id: widget.id, ...widget.data() };
}

// get Triggers by propertyId
export async function getTriggersByPropertyId(selectedProperty) {
  const triggerRef = getTriggersCollection();
  const triggerQuery = query(
    triggerRef,
    where("property", "==", selectedProperty)
  );

  return (await getDocs(triggerQuery)).docs.map((row) => ({
    ...row.data(),
    id: row.id,
  }));
}

export async function addMinMaxLog(data, log) {
  const { identifier, session } = data;
  let visitor = await getVisitor(identifier);
  const visitorRef = await getVisitorRef(identifier);
  const sessionRef = await getSessionRef(visitorRef, session);
  const activityRef = await getActivitiesCollectionRef(sessionRef);

  await addDoc(activityRef, {
    type: MESSAGE_TYPES.log,
    body: `${visitor?.name} has ${log} the chat.`,
    isVisitor: true,
    created_at: serverTimestamp(),
  }).catch((err) => {
    console.error(err);
  });
}
